/**
 * 前端官网页面
 */
const frontPage = [
  {
    name: '云展动力首页',
    path: '/',
    clickable: true,
    isShow: true,
  },
  {
    name: '关于我们',
    path: '/aboutus',
    clickable: false,
    isShow: true,
  },
  {
    name: '新手指南',
    path: '/guide',
    clickable: false,
    isShow: true,
  },
  {
    name: '商务合作',
    path: '/partner',
    clickable: false,
    isShow: true,
  },
  {
    name: '意见反馈',
    path: '/feedback',
    clickable: false,
    isShow: true,
  },
  {
    name: '联系我们',
    path: '/contact',
    clickable: false,
    isShow: true,
  },
  // TODO 先隐藏, 等运营的文档
  // {
  //   name: '帮助中心',
  //   path: '/help',
  //   clickable: false,
  //   isShow: true
  // },
  {
    name: '隐私权政策',
    path: '/privacy',
    clickable: false,
    isShow: true,
  },
  {
    name: '版权政策与法律说明',
    path: '/copyright-legal-disclaimer',
    clickable: false,
    isShow: true,
  },
  {
    name: '平台公告',
    path: '/platformNotice',
    clickable: false,
    isShow: true,
  },
  {
    name: '展厅服务',
    path: '/showroom',
    clickable: true,
    isShow: true,
  },
  {
    name: '展厅模型',
    path: '/showroom/model',
    clickable: true,
    isShow: false,
  },
  {
    name: '展厅工程商',
    path: '/showroom/build',
    clickable: false,
    isShow: false,
  },
  {
    name: '展厅设计师',
    path: '/showroom/designer',
    clickable: false,
    isShow: false,
  },
  {
    name: '企业展品',
    path: '/product',
    clickable: true,
    isShow: false,
  },
  {
    name: '全球会议',
    path: '/meeting',
    clickable: true,
    isShow: false,
  },
  {
    name: '产业头条',
    path: '/news',
    clickable: true,
    isShow: false,
  },
  {
    name: '云招聘',
    path: '/recruit',
    clickable: true,
    isShow: false,
  },
  {
    name: '招标服务',
    path: '/bidding',
    clickable: true,
    isShow: false,
  },
  {
    name: '全球展览',
    path: '/exhibition',
    clickable: true,
    isShow: false,
  },
  {
    name: '回放页',
    path: '/live/replayList',
    clickable: true,
    isShow: false,
  },
]
/**
 * 参观商
 */
const visitor = [
  {
    name: '会员中心',
    path: '/visitor',
    clickable: true,
    isShow: true,
  },
  {
    name: '招标管理',
    path: '/visitor/bidding',
    clickable: true,
    isShow: true,
  },
  {
    name: '发布招标',
    path: '/visitor/bidding/release',
    clickable: true,
    isShow: true,
  },
  // {
  //   name: '申请成为主办商',
  //   path: '/visitor/apply?applyType=2',
  //   clickable: true,
  //   isShow: true
  // },
  // {
  //   name: '申请成为参展商',
  //   path: '/visitor/apply?applyType=3',
  //   clickable: true,
  //   isShow: true
  // },
  // {
  //   name: '申请成为展厅工程商',
  //   path: '/visitor/apply?applyType=4',
  //   clickable: true,
  //   isShow: true
  // },
  // {
  //   name: '申请成为设计师（企业）',
  //   path: '/visitor/apply?applyType=5&applyIdentityType=a',
  //   clickable: true,
  //   isShow: true
  // },
  // {
  //   name: '申请成为设计师（个人）',
  //   path: '/visitor/apply?applyType=5&applyIdentityType=b',
  //   clickable: true,
  //   isShow: true
  // },
  {
    name: '我的展览',
    path: '/visitor/myExhibit',
    clickable: false,
    isShow: true,
  },
  {
    name: '参观报名',
    path: '/visitor/myExhibit/visitSignup',
    clickable: true,
    isShow: true,
  },
  {
    name: '我的会议',
    path: '/visitor/myMeeting',
    clickable: false,
    isShow: true,
  },
  {
    name: '参加报名',
    path: '/visitor/myMeeting/join',
    clickable: true,
    isShow: true,
  },
  {
    name: '会议赞助',
    path: '/visitor/myMeeting/sponsor',
    clickable: true,
    isShow: true,
  },
  {
    name: '海报管理',
    path: '/visitor/poster',
    clickable: false,
    isShow: true,
  },
  {
    name: '订单管理',
    path: '/visitor/order',
    clickable: true,
    isShow: true,
  },
  {
    name: '订单详情',
    path: '/visitor/order/detail',
    clickable: false,
    isShow: true,
  },
  {
    name: '我的海报',
    path: '/visitor/poster/poster',
    clickable: true,
    isShow: true,
  },
  {
    name: '我的采购',
    path: '/visitor/procurement',
    clickable: true,
    isShow: true,
  },
  {
    name: '我的名片',
    path: '/visitor/card',
    clickable: true,
    isShow: true,
  },
  {
    name: '我的收藏',
    path: '/visitor/keep',
    clickable: true,
    isShow: true,
  },
  {
    name: '采购详情',
    path: '/visitor/procurement/detail',
    clickable: false,
    isShow: true,
  },
  // 基本资料
  {
    name: '基本资料',
    path: '/visitor/basicInfo',
    clickable: true,
    isShow: true,
  },
  {
    name: '基础资料编辑',
    path: '/visitor/basicInfo/release',
    clickable: true,
    isShow: true,
  },
  {
    name: '我的钱包',
    path: '/visitor/account',
    clickable: true,
    isShow: true,
  },
  {
    name: '开通会员',
    path: '/visitor/account/vip',
    clickable: false,
    isShow: true,
  },
  {
    name: '消息中心',
    path: '/visitor/notifications',
    clickable: true,
    isShow: true,
  },
  {
    name: '短信邀约',
    path: '/visitor/dataMarketing/preciseInvitation/china',
    clickable: false,
    isShow: true,
  },
  {
    name: '链接管理',
    path: '/visitor/dataMarketing/preciseInvitation/link/china',
    clickable: true,
    isShow: true,
  },
  {
    name: '邮件邀约',
    path: '/visitor/dataMarketing/preciseInvitation/international',
    clickable: false,
    isShow: true,
  },
  {
    name: '精准邀约',
    path: '/visitor/dataMarketing/invite',
    clickable: true,
    isShow: true,
  },
  {
    name: '邀约模板',
    path: '/visitor/dataMarketing/invite/template',
    clickable: true,
    isShow: true,
  },
  {
    name: '邀约效果',
    path: '/visitor/dataMarketing/invite/effect/index',
    clickable: true,
    isShow: true,
  },
  {
    name: '邀约效果详情',
    path: '/visitor/dataMarketing/invite/effect/detail',
    clickable: false,
    isShow: false,
  },
  {
    name: '邀约记录',
    path: '/visitor/dataMarketing/invite/record',
    clickable: true,
    isShow: true,
  },
  {
    name: '创建普通邀约模板',
    path: '/visitor/dataMarketing/addOrdinaryTemplata',
    clickable: true,
    isShow: true,
  },
  {
    name: '创建多媒体邀约模板',
    path: '/visitor/dataMarketing/addFxTemplata',
    clickable: true,
    isShow: true,
  },
  {
    name: '邀约模板详情',
    path: '/visitor/dataMarketing/smsTemplataDetail',
    clickable: true,
    isShow: true,
  },
  {
    name: '发送平台邀约',
    path: '/visitor/dataMarketing/enterSMS',
    clickable: true,
    isShow: true,
  },
  {
    name: '链接详情',
    path: '/visitor/dataMarketing/linkDetail',
    clickable: true,
    isShow: true,
  },
]
/**
 * 主办商
 */
const organizer = [
  {
    name: '会员中心',
    path: '/organizer',
    clickable: true,
    isShow: true,
  },
  {
    name: '客户数据',
    path: '/organizer/data',
    clickable: true,
    isShow: true,
  },
  {
    name: '招标管理',
    path: '/organizer/bidding',
    clickable: true,
    isShow: true,
  },
  {
    name: '发布招标',
    path: '/organizer/bidding/release',
    clickable: true,
    isShow: true,
  },
  {
    name: '更新主办商资料',
    path: '/organizer/basicInfo/apply?applyType=2',
    clickable: false,
    isShow: true,
  },
  {
    name: '子账号管理',
    path: '/organizer/ram',
    clickable: true,
    isShow: true,
  },
  {
    name: '子账号详情',
    path: '/organizer/ram/detail',
    clickable: false,
    isShow: true,
  },
  {
    name: '客户列表',
    path: '/organizer/customer',
    clickable: false,
    isShow: true,
  },
  {
    name: '客户详情',
    path: '/organizer/customer/detail',
    clickable: false,
    isShow: true,
  },
  {
    name: '订单管理',
    path: '/organizer/order',
    clickable: true,
    isShow: true,
  },
  {
    name: '订单详情',
    path: '/organizer/order/detail',
    clickable: false,
    isShow: true,
  },
  {
    name: '发票管理',
    path: '/organizer/invoice',
    clickable: true,
    isShow: true,
  },
  {
    name: '发票详情',
    path: '/organizer/invoice/detail',
    clickable: false,
    isShow: true,
  },
  {
    name: '我的展览',
    path: '/organizer/myExhibit',
    clickable: false,
    isShow: true,
  },
  {
    name: '参观报名',
    path: '/organizer/myExhibit/visitSignup',
    clickable: true,
    isShow: true,
  },
  {
    name: '展厅搭建报名',
    path: '/organizer/myExhibit/buildSignup',
    clickable: true,
    isShow: true,
  },
  {
    name: '展览管理',
    path: '/organizer/exhibition',
    clickable: true,
    isShow: true,
  },
  {
    name: '发布新展览',
    path: '/organizer/exhibition/release',
    clickable: true,
    isShow: true,
  },
  {
    name: '详情',
    path: '/organizer/exhibition/detail',
    clickable: false,
    isShow: true,
  },
  {
    name: '参展商列表',
    path: '/organizer/exhibition/exhibitList',
    clickable: false,
    isShow: true,
  },
  {
    name: '标签列表',
    path: '/organizer/exhibition/labelList',
    clickable: false,
    isShow: true,
  },
  {
    name: '参观商列表',
    path: '/organizer/exhibition/visitList',
    clickable: false,
    isShow: true,
  },
  {
    name: '已上架的产品',
    path: '/organizer/exhibition/productList',
    clickable: false,
    isShow: true,
  },
  {
    name: '展台搭建列表',
    path: '/organizer/exhibition/boothList',
    clickable: false,
    isShow: true,
  },
  {
    name: '直播回放视频列表',
    path: '/organizer/exhibition/liveReplay',
    clickable: false,
    isShow: true,
  },
  {
    name: '直播回放视频列表',
    path: '/organizer/meeting/liveReplay',
    clickable: false,
    isShow: true,
  },
  {
    name: '会议管理',
    path: '/organizer/meeting',
    clickable: true,
    isShow: true,
  },
  {
    name: '发布新会议',
    path: '/organizer/meeting/release',
    clickable: true,
    isShow: true,
  },
  {
    name: '详情',
    path: '/organizer/meeting/detail',
    clickable: false,
    isShow: true,
  },
  {
    name: '会议赞助审核',
    path: '/organizer/meeting/sponsorDetail',
    clickable: false,
    isShow: true,
  },
  {
    name: '我的会议',
    path: '/organizer/myMeeting',
    clickable: false,
    isShow: true,
  },
  {
    name: '参加报名',
    path: '/organizer/myMeeting/join',
    clickable: true,
    isShow: true,
  },
  {
    name: '会议赞助',
    path: '/organizer/myMeeting/sponsor',
    clickable: true,
    isShow: true,
  },
  {
    name: '参会商列表',
    path: '/organizer/meeting/attendList',
    clickable: false,
    isShow: true,
  },
  {
    name: '赞助商列表',
    path: '/organizer/meeting/sponsorList',
    clickable: true,
    isShow: true,
  },
  {
    name: '展台搭建列表',
    path: '/organizer/meeting/boothList',
    clickable: false,
    isShow: true,
  },
  {
    name: '头条管理',
    path: '/organizer/information',
    clickable: true,
    isShow: true,
  },
  {
    name: '我的直播',
    path: '/organizer/myLive',
    clickable: true,
    isShow: true,
  },
  {
    name: '发布新头条',
    path: '/organizer/information/release',
    clickable: true,
    isShow: true,
  },
  {
    name: '详情',
    path: '/organizer/information/detail',
    clickable: false,
    isShow: true,
  },
  {
    name: '海报管理',
    path: '/organizer/poster',
    clickable: true,
    isShow: true,
  },
  {
    name: '优惠券',
    path: '/organizer/coupon',
    clickable: true,
    isShow: true,
  },
  {
    name: '我的收藏',
    path: '/organizer/keep',
    clickable: true,
    isShow: true,
  },
  {
    name: '我的采购',
    path: '/organizer/procurement',
    clickable: true,
    isShow: true,
  },
  {
    name: '采购详情',
    path: '/organizer/procurement/detail',
    clickable: false,
    isShow: true,
  },
  {
    name: '海报管理',
    path: '/organizer/poster',
    clickable: false,
    isShow: true,
  },
  {
    name: '我的海报',
    path: '/organizer/poster/poster',
    clickable: true,
    isShow: true,
  },
  {
    name: '基本资料',
    path: '/organizer/basicInfo',
    clickable: true,
    isShow: true,
  },
  {
    name: '基础资料编辑',
    path: '/organizer/basicInfo/release',
    clickable: true,
    isShow: true,
  },
  {
    name: '客户管理系统',
    path: '/organizer/cces',
    clickable: false,
    isShow: true,
  },
  {
    name: '企业云展',
    path: '/organizer/cces/cloud',
    clickable: true,
    isShow: true,
  },
  {
    name: '企业动态',
    path: '/organizer/cces/dynamic',
    clickable: true,
    isShow: true,
  },
  {
    name: '云优惠',
    path: '/organizer/cces/offers',
    clickable: false,
    isShow: true,
  },
  {
    name: '企业客户数据',
    path: '/organizer/cces/count',
    clickable: false,
    isShow: true,
  },
  {
    name: '企业数据',
    path: '/organizer/cces/count/subAccount',
    clickable: true,
    isShow: true,
  },
  {
    name: '客户管理',
    path: '/organizer/cces/count/customerData',
    clickable: true,
    isShow: true,
  },
  {
    name: '企业子账号详情',
    path: '/organizer/cces/count/subAccountDetail',
    clickable: true,
    isShow: false,
  },
  {
    name: '客户管理',
    path: '/organizer/cces/count/customerManage',
    clickable: true,
    isShow: false,
  },

  {
    name: '我的名片',
    path: '/organizer/card',
    clickable: true,
    isShow: true,
  },
  {
    name: '我的收藏',
    path: '/organizer/keep',
    clickable: true,
    isShow: true,
  },
  {
    name: '我的钱包',
    path: '/organizer/account',
    clickable: true,
    isShow: true,
  },
  {
    name: '开通会员',
    path: '/organizer/account/vip',
    clickable: false,
    isShow: true,
  },
  {
    name: '消息中心',
    path: '/organizer/notifications',
    clickable: true,
    isShow: true,
  },
  {
    name: '大数据获客',
    path: '/organizer/dataMarketing',
    clickable: false,
    isShow: true,
  },
  {
    name: '外呼呼叫',
    path: '/organizer/dataMarketing/aiCall',
    clickable: false,
    isShow: true,
  },
  {
    name: '短信邀约',
    path: '/organizer/dataMarketing/preciseInvitation/china',
    clickable: false,
    isShow: true,
  },
  {
    name: '链接管理',
    path: '/organizer/dataMarketing/preciseInvitation/link/china',
    clickable: true,
    isShow: true,
  },
  {
    name: '邮件邀约',
    path: '/organizer/dataMarketing/preciseInvitation/international',
    clickable: false,
    isShow: true,
  },
  {
    name: '精准邀约',
    path: '/organizer/dataMarketing/invite',
    clickable: true,
    isShow: true,
  },
  {
    name: '邀约模板',
    path: '/organizer/dataMarketing/invite/template',
    clickable: true,
    isShow: true,
  },
  {
    name: '邀约效果',
    path: '/organizer/dataMarketing/invite/effect/index',
    clickable: true,
    isShow: true,
  },
  {
    name: '邀约效果详情',
    path: '/organizer/dataMarketing/invite/effect/detail',
    clickable: false,
    isShow: false,
  },
  {
    name: '邀约记录',
    path: '/organizer/dataMarketing/invite/record',
    clickable: true,
    isShow: true,
  },
  {
    name: '创建普通邀约模板',
    path: '/organizer/dataMarketing/addOrdinaryTemplata',
    clickable: true,
    isShow: true,
  },
  {
    name: '创建多媒体邀约模板',
    path: '/organizer/dataMarketing/addFxTemplata',
    clickable: true,
    isShow: true,
  },
  {
    name: '邀约模板详情',
    path: '/organizer/dataMarketing/smsTemplataDetail',
    clickable: true,
    isShow: true,
  },
  {
    name: '发送平台邀约',
    path: '/organizer/dataMarketing/enterSMS',
    clickable: true,
    isShow: true,
  },
  {
    name: '链接详情',
    path: '/organizer/dataMarketing/linkDetail',
    clickable: true,
    isShow: true,
  },
  {
    name: '效果',
    path: '/organizer/dataMarketing/effect',
    clickable: true,
    isShow: true,
  },
  {
    name: '客户库',
    path: '/organizer/dataMarketing/addressBook',
    clickable: true,
    isShow: true,
  },
  {
    name: '新增客户',
    path: '/organizer/dataMarketing/addressBook/addClient',
    clickable: true,
    isShow: true,
  },
  {
    name: '自主新增',
    path: '/organizer/dataMarketing/addressBook/selfAddedCustomersFrom',
    clickable: true,
    isShow: true,
  },
  {
    name: '云数据',
    path: '/organizer/dataMarketing/cloudData',
    clickable: true,
    isShow: true,
  },
]
/**
 * 参展商
 */
const exhibitor = [
  {
    name: '会员中心',
    path: '/exhibitor',
    clickable: true,
    isShow: true,
  },
  {
    name: '客户数据',
    path: '/exhibitor/data',
    clickable: true,
    isShow: true,
  },
  {
    name: '客户管理系统',
    path: '/exhibitor/cces',
    clickable: false,
    isShow: true,
  },
  {
    name: '云优惠',
    path: '/exhibitor/cces/offers',
    clickable: false,
    isShow: true,
  },
  {
    name: '企业云展',
    path: '/exhibitor/cces/cloud',
    clickable: false,
    isShow: true,
  },
  {
    name: '企业动态',
    path: '/exhibitor/cces/dynamic',
    clickable: true,
    isShow: true,
  },
  {
    name: '企业数据',
    path: '/exhibitor/cces/count/subAccount',
    clickable: true,
    isShow: true,
  },
  {
    name: '企业子账号详情',
    path: '/exhibitor/cces/count/subAccountDetail',
    clickable: true,
    isShow: false,
  },
  {
    name: '招标管理',
    path: '/exhibitor/bidding',
    clickable: true,
    isShow: true,
  },
  {
    name: '我的直播',
    path: '/exhibitor/myLive',
    clickable: true,
    isShow: true,
  },
  {
    name: '发布招标',
    path: '/exhibitor/bidding/release',
    clickable: true,
    isShow: true,
  },
  {
    name: '更新参展商资料',
    path: '/exhibitor/basicInfo/apply?applyType=3',
    clickable: false,
    isShow: true,
  },
  {
    name: '子账号管理',
    path: '/exhibitor/ram',
    clickable: true,
    isShow: true,
  },
  {
    name: '子账号详情',
    path: '/exhibitor/ram/detail',
    clickable: false,
    isShow: true,
  },
  {
    name: '客户列表',
    path: '/exhibitor/customer',
    clickable: false,
    isShow: true,
  },
  {
    name: '客户详情',
    path: '/exhibitor/customer/detail',
    clickable: false,
    isShow: true,
  },
  {
    name: '订单管理',
    path: '/exhibitor/order',
    clickable: true,
    isShow: true,
  },
  {
    name: '订单详情',
    path: '/exhibitor/order/detail',
    clickable: false,
    isShow: true,
  },
  {
    name: '发票管理',
    path: '/exhibitor/invoice',
    clickable: true,
    isShow: true,
  },
  {
    name: '发票详情',
    path: '/exhibitor/invoice/detail',
    clickable: false,
    isShow: true,
  },
  // 我的展览
  {
    name: '我的展览',
    path: '/exhibitor/myExhibit',
    clickable: false,
    isShow: true,
  },
  {
    name: '参展报名',
    path: '/exhibitor/myExhibit/exhibitSignup',
    clickable: true,
    isShow: true,
  },
  {
    name: '参观报名',
    path: '/exhibitor/myExhibit/visitSignup',
    clickable: true,
    isShow: true,
  },
  {
    name: '我的会议',
    path: '/exhibitor/myMeeting',
    clickable: false,
    isShow: true,
  },
  {
    name: '参加报名',
    path: '/exhibitor/myMeeting/join',
    clickable: true,
    isShow: true,
  },
  {
    name: '会议赞助',
    path: '/exhibitor/myMeeting/sponsor',
    clickable: true,
    isShow: true,
  },
  {
    name: '展厅搭建报名',
    path: '/exhibitor/myExhibit/buildSignup',
    clickable: true,
    isShow: true,
  },
  {
    name: '看直播',
    path: '/exhibitor/myExhibit/liveList',
    clickable: false,
    isShow: true,
  },
  {
    name: '参展产品',
    path: '/exhibitor/myExhibit/productList',
    clickable: false,
    isShow: true,
  },
  // 产品管理
  {
    name: '产品服务',
    path: '/exhibitor/product',
    clickable: true,
    isShow: true,
  },
  {
    name: '发布产品',
    path: '/exhibitor/product/release',
    clickable: true,
    isShow: true,
  },
  {
    name: '产品详情',
    path: '/exhibitor/product/detail',
    clickable: true,
    isShow: true,
  },
  // 采购管理
  {
    name: '采购管理',
    path: '/exhibitor/procurement',
    clickable: false,
    isShow: true,
  },
  {
    name: '客户采购单',
    path: '/exhibitor/procurement/customer',
    clickable: true,
    isShow: true,
  },
  {
    name: '我的采购单',
    path: '/exhibitor/procurement',
    clickable: true,
    isShow: true,
  },
  {
    name: '采购详情',
    path: '/exhibitor/procurement/detail',
    clickable: false,
    isShow: true,
  },
  // 海报管理
  {
    name: '海报管理',
    path: '/exhibitor/poster',
    clickable: false,
    isShow: true,
  },
  {
    name: '我的海报',
    path: '/exhibitor/poster/poster',
    clickable: true,
    isShow: true,
  },
  // 基本资料
  {
    name: '基本资料',
    path: '/exhibitor/basicInfo',
    clickable: true,
    isShow: true,
  },
  {
    name: '基础资料编辑',
    path: '/exhibitor/basicInfo/release',
    clickable: true,
    isShow: true,
  },
  {
    name: '我的名片',
    path: '/exhibitor/card',
    clickable: true,
    isShow: true,
  },
  {
    name: '我的名片编辑',
    path: '/exhibitor/myCloudCompany/editor/companyInfo',
    isShow: true,
  },
  {
    name: '我的钱包',
    path: '/exhibitor/account',
    clickable: true,
    isShow: true,
  },
  {
    name: '开通会员',
    path: '/exhibitor/account/vip',
    clickable: false,
    isShow: true,
  },
  {
    name: '我的收藏',
    path: '/exhibitor/keep',
    clickable: true,
    isShow: true,
  },
  {
    name: '消息中心',
    path: '/exhibitor/notifications',
    clickable: true,
    isShow: true,
  },
  {
    name: '大数据获客',
    path: '/exhibitor/dataMarketing',
    clickable: false,
    isShow: true,
  },
  {
    name: '外呼呼叫',
    path: '/exhibitor/dataMarketing/aiCall',
    clickable: false,
    isShow: true,
  },
  {
    name: '短信邀约',
    path: '/exhibitor/dataMarketing/preciseInvitation/china',
    clickable: false,
    isShow: true,
  },
  {
    name: '链接管理',
    path: '/exhibitor/dataMarketing/preciseInvitation/link/china',
    clickable: true,
    isShow: true,
  },
  {
    name: '邮件邀约',
    path: '/exhibitor/dataMarketing/preciseInvitation/international',
    clickable: false,
    isShow: true,
  },
  {
    name: '精准邀约',
    path: '/exhibitor/dataMarketing/invite',
    clickable: true,
    isShow: true,
  },
  {
    name: '邀约模板',
    path: '/exhibitor/dataMarketing/invite/template',
    clickable: true,
    isShow: true,
  },
  {
    name: '邀约效果',
    path: '/exhibitor/dataMarketing/invite/effect/index',
    clickable: true,
    isShow: true,
  },
  {
    name: '邀约效果详情',
    path: '/exhibitor/dataMarketing/invite/effect/detail',
    clickable: false,
    isShow: false,
  },
  {
    name: '邀约记录',
    path: '/exhibitor/dataMarketing/invite/record',
    clickable: true,
    isShow: true,
  },
  {
    name: '创建普通邀约模板',
    path: '/exhibitor/dataMarketing/addOrdinaryTemplata',
    clickable: true,
    isShow: true,
  },
  {
    name: '创建多媒体邀约模板',
    path: '/exhibitor/dataMarketing/addFxTemplata',
    clickable: true,
    isShow: true,
  },
  {
    name: '邀约模板详情',
    path: '/exhibitor/dataMarketing/smsTemplataDetail',
    clickable: true,
    isShow: true,
  },
  {
    name: '发送平台邀约',
    path: '/exhibitor/dataMarketing/enterSMS',
    clickable: true,
    isShow: true,
  },
  {
    name: '链接详情',
    path: '/exhibitor/dataMarketing/linkDetail',
    clickable: true,
    isShow: true,
  },
  {
    name: '效果',
    path: '/exhibitor/dataMarketing/effect',
    clickable: true,
    isShow: true,
  },
  {
    name: '客户库',
    path: '/exhibitor/dataMarketing/addressBook',
    clickable: true,
    isShow: true,
  },
  {
    name: '新增客户',
    path: '/exhibitor/dataMarketing/addressBook/addClient',
    clickable: true,
    isShow: true,
  },
  {
    name: '自主新增',
    path: '/exhibitor/dataMarketing/addressBook/selfAddedCustomersFrom',
    clickable: true,
    isShow: true,
  },
  {
    name: '云数据',
    path: '/exhibitor/dataMarketing/cloudData',
    clickable: true,
    isShow: true,
  },
]
/**
 * 工程商
 */
const contractors = [
  {
    name: '会员中心',
    path: '/contractors',
    clickable: true,
    isShow: true,
  },
  {
    name: '客户数据',
    path: '/contractors/data',
    clickable: true,
    isShow: true,
  },
  {
    name: '客户管理系统',
    path: '/contractors/cces',
    clickable: false,
    isShow: true,
  },
  {
    name: '企业云展',
    path: '/contractors/cces/cloud',
    clickable: true,
    isShow: true,
  },
  {
    name: '企业动态',
    path: '/contractors/cces/dynamic',
    clickable: true,
    isShow: true,
  },
  {
    name: '企业数据',
    path: '/contractors/cces/count/subAccount',
    clickable: true,
    isShow: true,
  },
  {
    name: '企业子账号详情',
    path: '/contractors/cces/count/subAccountDetail',
    clickable: false,
    isShow: true,
  },
  {
    name: '子账号管理',
    path: '/contractors/ram',
    clickable: true,
    isShow: true,
  },
  {
    name: '子账号详情',
    path: '/contractors/ram/detail',
    clickable: false,
    isShow: true,
  },
  {
    name: '客户列表',
    path: '/contractors/customer',
    clickable: false,
    isShow: true,
  },
  {
    name: '客户详情',
    path: '/contractors/customer/detail',
    clickable: false,
    isShow: true,
  },
  {
    name: '招标管理',
    path: '/contractors/bidding',
    clickable: true,
    isShow: true,
  },
  {
    name: '发布招标',
    path: '/contractors/bidding/release',
    clickable: true,
    isShow: true,
  },
  {
    name: '我的展览',
    path: '/contractors/myExhibit',
    clickable: false,
    isShow: true,
  },
  {
    name: '参观报名',
    path: '/contractors/myExhibit/visitSignup',
    clickable: true,
    isShow: true,
  },
  {
    name: '更新工程商资料',
    path: '/contractors/basicInfo/apply?applyType=4',
    clickable: false,
    isShow: true,
  },
  {
    name: '展厅管理',
    path: '/contractors/showroom',
    clickable: true,
    isShow: true,
  },
  {
    name: '订单管理',
    path: '/contractors/order',
    clickable: true,
    isShow: true,
  },
  {
    name: '发票管理',
    path: '/contractors/invoice',
    clickable: true,
    isShow: true,
  },
  {
    name: '发票详情',
    path: '/contractors/invoice/detail',
    clickable: false,
    isShow: true,
  },
  {
    name: '订单详情',
    path: '/contractors/order/detail',
    clickable: false,
    isShow: true,
  },
  {
    name: '定制管理',
    path: '/contractors/customize',
    clickable: true,
    isShow: true,
  },
  {
    name: '我的采购',
    path: '/contractors/procurement',
    clickable: true,
    isShow: true,
  },
  {
    name: '我的会议',
    path: '/contractors/myMeeting',
    clickable: false,
    isShow: true,
  },
  {
    name: '参加报名',
    path: '/contractors/myMeeting/join',
    clickable: true,
    isShow: true,
  },
  {
    name: '会议赞助',
    path: '/contractors/myMeeting/sponsor',
    clickable: true,
    isShow: true,
  },
  // 基本资料
  {
    name: '基本资料',
    path: '/contractors/basicInfo',
    clickable: true,
    isShow: true,
  },
  {
    name: '基础资料编辑',
    path: '/contractors/basicInfo/release',
    clickable: true,
    isShow: true,
  },
  {
    name: '海报管理',
    path: '/contractors/poster',
    clickable: false,
    isShow: true,
  },
  {
    name: '我的海报',
    path: '/contractors/poster/poster',
    clickable: true,
    isShow: true,
  },
  {
    name: '我的名片',
    path: '/contractors/card',
    clickable: true,
    isShow: true,
  },
  {
    name: '采购详情',
    path: '/contractors/procurement/detail',
    clickable: false,
    isShow: true,
  },
  {
    name: '我的钱包',
    path: '/contractors/account',
    clickable: true,
    isShow: true,
  },
  {
    name: '开通会员',
    path: '/contractors/account/vip',
    clickable: false,
    isShow: true,
  },
  {
    name: '我的收藏',
    path: '/contractors/keep',
    clickable: true,
    isShow: true,
  },
  {
    name: '消息中心',
    path: '/contractors/notifications',
    clickable: true,
    isShow: true,
  },
  {
    name: '大数据获客',
    path: '/contractors/dataMarketing',
    clickable: false,
    isShow: true,
  },
  {
    name: '外呼呼叫',
    path: '/contractors/dataMarketing/aiCall',
    clickable: false,
    isShow: true,
  },
  {
    name: '短信邀约',
    path: '/contractors/dataMarketing/preciseInvitation/china',
    clickable: false,
    isShow: true,
  },
  {
    name: '链接管理',
    path: '/contractors/dataMarketing/preciseInvitation/link/china',
    clickable: true,
    isShow: true,
  },
  {
    name: '邮件邀约',
    path: '/contractors/dataMarketing/preciseInvitation/international',
    clickable: false,
    isShow: true,
  },
  {
    name: '精准邀约',
    path: '/contractors/dataMarketing/invite',
    clickable: true,
    isShow: true,
  },
  {
    name: '邀约模板',
    path: '/contractors/dataMarketing/invite/template',
    clickable: true,
    isShow: true,
  },
  {
    name: '邀约效果',
    path: '/contractors/dataMarketing/invite/effect/index',
    clickable: true,
    isShow: true,
  },
  {
    name: '邀约效果详情',
    path: '/contractors/dataMarketing/invite/effect/detail',
    clickable: false,
    isShow: false,
  },
  {
    name: '邀约记录',
    path: '/contractors/dataMarketing/invite/record',
    clickable: true,
    isShow: true,
  },
  {
    name: '创建普通邀约模板',
    path: '/contractors/dataMarketing/addOrdinaryTemplata',
    clickable: true,
    isShow: true,
  },
  {
    name: '创建多媒体邀约模板',
    path: '/contractors/dataMarketing/addFxTemplata',
    clickable: true,
    isShow: true,
  },
  {
    name: '邀约模板详情',
    path: '/contractors/dataMarketing/smsTemplataDetail',
    clickable: true,
    isShow: true,
  },
  {
    name: '发送平台邀约',
    path: '/contractors/dataMarketing/enterSMS',
    clickable: true,
    isShow: true,
  },
  {
    name: '链接详情',
    path: '/contractors/dataMarketing/linkDetail',
    clickable: true,
    isShow: true,
  },
  {
    name: '效果',
    path: '/contractors/dataMarketing/effect',
    clickable: true,
    isShow: true,
  },
  {
    name: '客户库',
    path: '/contractors/dataMarketing/addressBook',
    clickable: true,
    isShow: true,
  },
  {
    name: '新增客户',
    path: '/contractors/dataMarketing/addressBook/addClient',
    clickable: true,
    isShow: true,
  },
  {
    name: '自主新增',
    path: '/contractors/dataMarketing/addressBook/selfAddedCustomersFrom',
    clickable: true,
    isShow: true,
  },
  {
    name: '云数据',
    path: '/contractors/dataMarketing/cloudData',
    clickable: true,
    isShow: true,
  },
]

/**
 * 设计师
 */
const designer = [
  {
    name: '会员中心',
    path: '/designer',
    clickable: true,
    isShow: true,
  },
  {
    name: '客户数据',
    path: '/designer/data',
    clickable: true,
    isShow: true,
  },
  {
    name: '客户管理系统',
    path: '/designer/cces',
    clickable: false,
    isShow: true,
  },
  {
    name: '企业云展',
    path: '/designer/cces/cloud',
    clickable: true,
    isShow: true,
  },
  {
    name: '企业动态',
    path: '/designer/cces/dynamic',
    clickable: true,
    isShow: true,
  },
  {
    name: '企业数据',
    path: '/designer/cces/count/subAccount',
    clickable: true,
    isShow: true,
  },
  {
    name: '企业子账号详情',
    path: '/designer/cces/count/subAccountDetail',
    clickable: false,
    isShow: false,
  },
  {
    name: '子账号管理',
    path: '/designer/ram',
    clickable: true,
    isShow: true,
  },
  {
    name: '子账号详情',
    path: '/designer/ram/detail',
    clickable: false,
    isShow: true,
  },
  {
    name: '客户列表',
    path: '/designer/customer',
    clickable: false,
    isShow: true,
  },
  {
    name: '客户详情',
    path: '/designer/customer/detail',
    clickable: false,
    isShow: true,
  },
  {
    name: '招标管理',
    path: '/designer/bidding',
    clickable: true,
    isShow: true,
  },
  {
    name: '发布招标',
    path: '/designer/bidding/release',
    clickable: true,
    isShow: true,
  },
  {
    name: '更新设计师（企业）资料',
    path: '/designer/basicInfo/apply?applyType=5&applyIdentityType=a',
    clickable: true,
    isShow: true,
  },
  {
    name: '更新设计师（个人）资料',
    path: '/designer/basicInfo/apply?applyType=5&applyIdentityType=b',
    clickable: true,
    isShow: true,
  },
  {
    name: '定制管理',
    path: '/designer/customize',
    clickable: true,
    isShow: true,
  },
  {
    name: '订单管理',
    path: '/designer/order',
    clickable: true,
    isShow: true,
  },
  {
    name: '发票管理',
    path: '/designer/invoice',
    clickable: true,
    isShow: true,
  },
  {
    name: '发票详情',
    path: '/designer/invoice/detail',
    clickable: false,
    isShow: true,
  },
  {
    name: '订单详情',
    path: '/designer/order/detail',
    clickable: false,
    isShow: true,
  },
  {
    name: '我的展览',
    path: '/designer/myExhibit',
    clickable: false,
    isShow: true,
  },
  {
    name: '参加报名',
    path: '/designer/myExhibit/visitSignup',
    clickable: true,
    isShow: true,
  },
  {
    name: '我的会议',
    path: '/designer/myMeeting',
    clickable: false,
    isShow: true,
  },
  {
    name: '参加报名',
    path: '/designer/myMeeting/join',
    clickable: true,
    isShow: true,
  },
  {
    name: '会议赞助',
    path: '/designer/myMeeting/sponsor',
    clickable: true,
    isShow: true,
  },
  {
    name: '展厅管理',
    path: '/designer/showroom',
    clickable: true,
    isShow: true,
  },
  {
    name: '模型详情',
    path: '/designer/showroom/detail',
    clickable: false,
    isShow: true,
  },
  {
    name: '发布模型',
    path: '/designer/showroom/release',
    clickable: true,
    isShow: true,
  },
  {
    name: '我的采购',
    path: '/designer/procurement',
    clickable: true,
    isShow: true,
  },
  {
    name: '海报管理',
    path: '/designer/poster',
    clickable: false,
    isShow: true,
  },
  {
    name: '我的海报',
    path: '/designer/poster/poster',
    clickable: true,
    isShow: true,
  },
  {
    name: '作品管理',
    path: '/designer/poster/works',
    clickable: true,
    isShow: true,
  },
  // 基本资料
  {
    name: '基本资料',
    path: '/designer/basicInfo',
    clickable: true,
    isShow: true,
  },
  {
    name: '基础资料编辑',
    path: '/designer/basicInfo/release',
    clickable: true,
    isShow: true,
  },
  {
    name: '我的名片',
    path: '/designer/card',
    clickable: true,
    isShow: true,
  },
  {
    name: '采购详情',
    path: '/designer/procurement/detail',
    clickable: false,
    isShow: true,
  },
  {
    name: '我的钱包',
    path: '/designer/account',
    clickable: true,
    isShow: true,
  },
  {
    name: '开通会员',
    path: '/designer/account/vip',
    clickable: false,
    isShow: true,
  },
  {
    name: '我的收藏',
    path: '/designer/keep',
    clickable: true,
    isShow: true,
  },
  {
    name: '消息中心',
    path: '/designer/notifications',
    clickable: true,
    isShow: true,
  },
  {
    name: '大数据获客',
    path: '/designer/dataMarketing',
    clickable: false,
    isShow: true,
  },
  {
    name: '外呼呼叫',
    path: '/designer/dataMarketing/aiCall',
    clickable: false,
    isShow: true,
  },
  {
    name: '短信邀约',
    path: '/designer/dataMarketing/preciseInvitation/china',
    clickable: false,
    isShow: true,
  },
  {
    name: '链接管理',
    path: '/designer/dataMarketing/preciseInvitation/link/china',
    clickable: true,
    isShow: true,
  },
  {
    name: '邮件邀约',
    path: '/designer/dataMarketing/preciseInvitation/international',
    clickable: false,
    isShow: true,
  },
  {
    name: '精准邀约',
    path: '/designer/dataMarketing/invite',
    clickable: true,
    isShow: true,
  },
  {
    name: '邀约模板',
    path: '/designer/dataMarketing/invite/template',
    clickable: true,
    isShow: true,
  },
  {
    name: '邀约效果',
    path: '/designer/dataMarketing/invite/effect/index',
    clickable: true,
    isShow: true,
  },
  {
    name: '邀约效果详情',
    path: '/designer/dataMarketing/invite/effect/detail',
    clickable: false,
    isShow: false,
  },
  {
    name: '邀约记录',
    path: '/designer/dataMarketing/invite/record',
    clickable: true,
    isShow: true,
  },
  {
    name: '创建普通邀约模板',
    path: '/designer/dataMarketing/addOrdinaryTemplata',
    clickable: true,
    isShow: true,
  },
  {
    name: '创建多媒体邀约模板',
    path: '/designer/dataMarketing/addFxTemplata',
    clickable: true,
    isShow: true,
  },
  {
    name: '邀约模板详情',
    path: '/designer/dataMarketing/smsTemplataDetail',
    clickable: true,
    isShow: true,
  },
  {
    name: '发送平台邀约',
    path: '/designer/dataMarketing/enterSMS',
    clickable: true,
    isShow: true,
  },
  {
    name: '链接详情',
    path: '/designer/dataMarketing/linkDetail',
    clickable: true,
    isShow: true,
  },
  {
    name: '效果',
    path: '/designer/dataMarketing/effect',
    clickable: true,
    isShow: true,
  },
  {
    name: '客户库',
    path: '/designer/dataMarketing/addressBook',
    clickable: true,
    isShow: true,
  },
  {
    name: '新增客户',
    path: '/designer/dataMarketing/addressBook/addClient',
    clickable: true,
    isShow: true,
  },
  {
    name: '自主新增',
    path: '/designer/dataMarketing/addressBook/selfAddedCustomersFrom',
    clickable: true,
    isShow: true,
  },
  {
    name: '云数据',
    path: '/designer/dataMarketing/cloudData',
    clickable: true,
    isShow: true,
  },
]

export const breadcrumbsJson = [...frontPage, ...visitor, ...organizer, ...exhibitor, ...contractors, ...designer]
export const detailJson = [
  {
    name: '展品详情',
    path: '/product/',
    isReplace: true,
  },
  {
    name: '会议详情',
    path: '/meeting/',
    isReplace: true,
  },
  {
    name: '头条详情',
    path: '/news/',
    isReplace: true,
  },
]
